import "./StoreBanner.scss";

export const StoreBanner = (props) => {
  const { packageData } = props;

  return (
    <div className="user-dashboard-store-banner-inner-wrapper">
      <div className="store-banner-content-and-btn-wrapper">
        <img src={packageData?.icon} alt="Banner" className="banner-image" />
      </div>
    </div>
  );
};
